/* eslint-disable @typescript-eslint/no-unused-vars */

import { GamoraFoundationNodeArgs } from '@ver.id/libs.internal.gamora';
import { HoruzProtocolChulakClientStateBase } from './base.js';
import { HoruzProtocolChulakClientStateContext } from '../context.js';
import { HoruzProtocolChulakClientStateEvent } from './enums.js';
import { HoruzProtocolChulakClientStateMap } from '../../statemap.js';
import { IHoruz } from '../../../../horuz.js';

/**
 * Client
 *
 * Done state
 * @public
 */
export class HoruzProtocolChulakClientStateDone extends HoruzProtocolChulakClientStateBase<
  typeof HoruzProtocolChulakClientStateMap,
  HoruzProtocolChulakClientStateContext,
  IHoruz
> {
  constructor(args: GamoraFoundationNodeArgs) {
    super(args);
  }
  /**
   * Enter state
   */
  override async $enter(
    clientStateContext: HoruzProtocolChulakClientStateContext,
  ): Promise<void> {
    // Invoke abortion handler
    this.$emit(
      clientStateContext.contextIdentifier,
      HoruzProtocolChulakClientStateEvent.Done,
    );
  }

  /**
   * Exit state
   */
  override async $exit(
    clientStateContext: HoruzProtocolChulakClientStateContext,
  ): Promise<void> {}
}
